module.exports = __webpack_public_path__ + "img/2-2.cfa1bd91.svg";